module.exports = __webpack_public_path__ + "img/Ad_1__Shipbuilding.9470afe6.jpg";